import React from "react";
import "./App.css";
import Login from "./views/auth/Login";
import Confirm from "./views/auth/Confirm";
import Setup from "./views/auth/Setup";
import { connect } from "react-redux";
import tl from "./lib/teachlink/TeachLinkAPI";
import { user_logged_in, user_logged_out } from "./lib/actions";
import Main from "./views/Main";
import { ThemeProvider } from "@mui/styles";
//import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import blue from "@mui/material/colors/blue";
import Loading from "./views/general/Loading";
import InviteLogin from "./views/auth/InviteLogin";
import Welcome from "./views/pages/Welcome";
import More from "./views/pages/static/More";
import Pricing from "./views/pages/static/Pricing";
import TakeSurvey from "./views/pages/TakeSurvey";
import Order from "./views/pages/static/Order";
import Value from "./views/pages/static/Value";
import ThankYou from "./views/pages/static/ThankYou";
import Validation from "./views/pages/static/Validation";
// Sidebar menu commented out - replaced with top nav dropdowns
// import SidebarMenu from "./views/general/SidebarMenu";
import NECLTC from "./views/pages/static/NECLTC";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import { BrowserRouter, Route, Switch } from "react-router-dom";

// Navigation dropdown menu items configuration
const NAV_DROPDOWNS = {
  about: {
    label: "About",
    items: [
      { label: "Validation Study", anchor: "validation-study" },
      { label: "Registration", anchor: "registration" },
      { label: "Evidence Base", anchor: "evidence-base" },
      { label: "Purpose & Use", anchor: "purpose-use" },
      { label: "Data", anchor: "data-section" },
    ],
  },
  framework: {
    label: "Framework",
    items: [
      { label: "Framework", anchor: "learn-more" },
      { label: "Implementation", anchor: "implementation" },
      { label: "Student Voice Survey", anchor: "student-voice" },
      { label: "Pricing", anchor: "pricing-welcome" },
      { label: "Letter", anchor: "letter-section" },
    ],
  },
  value: {
    label: "Value",
    items: [
      { label: "Value", anchor: "value-section" },
      { label: "Partners", anchor: "partners" },
      { label: "Contact Us", anchor: "contact-us" },
    ],
  },
};

const theme = createTheme({
  palette: {
    primary: blue,
    secondary: {
      light: "#c466c5",
      main: "#c466c5",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#fff",
    },
  },
});

type Props = {
  dispatch: (arg0: { type: string; user?: any }) => void;
  auth: {
    loggedIn: boolean;
  };
};

type State = {
  loading: boolean;
  show: boolean;
  school_admin?: boolean;
  sccate_admin?: boolean;
  sccate_admin_restricted?: boolean;
  user_can_manage?: boolean;
  // Dropdown anchor elements
  aboutAnchor: null | HTMLElement;
  frameworkAnchor: null | HTMLElement;
  valueAnchor: null | HTMLElement;
  navigationAnchor: null | HTMLElement;
  // Mobile menu state
  mobileMenuOpen: boolean;
};

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      show: false,
      sccate_admin: false,
      sccate_admin_restricted: false,
      user_can_manage: false,
      aboutAnchor: null,
      frameworkAnchor: null,
      valueAnchor: null,
      navigationAnchor: null,
      mobileMenuOpen: false,
    };
  }

  componentDidMount() {
    tl.authorize((user: any) => {
      user
        ? this.props.dispatch(user_logged_in(user))
        : this.props.dispatch(user_logged_out());
      this.setState({
        loading: false,
        sccate_admin: tl.user_is_sccate_admin(),
        sccate_admin_restricted: tl.user_is_restricted_sccate_admin(),
        user_can_manage: tl.user_can_manage_school(),
      });
    });
  }

  toggleDrawer = () => () => {
    this.setState({
      show: !this.state.show,
    });
  };

  // Dropdown handlers
  handleDropdownOpen = (dropdown: string) => (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ [`${dropdown}Anchor`]: event.currentTarget } as any);
  };

  handleDropdownClose = (dropdown: string) => () => {
    this.setState({ [`${dropdown}Anchor`]: null } as any);
  };

  // Smooth scroll to section
  scrollToSection = (anchor: string, dropdown: string) => () => {
    this.handleDropdownClose(dropdown)();
    this.setState({ mobileMenuOpen: false });
    // Navigate to home page first if not already there
    if (window.location.pathname !== "/") {
      window.location.href = `/#${anchor}`;
    } else {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  // Mobile menu toggle
  toggleMobileMenu = () => {
    this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen });
  };

  closeMobileMenu = () => {
    this.setState({ mobileMenuOpen: false });
  };

  // Mobile navigation handler
  handleMobileNavigation = (path: string) => {
    this.closeMobileMenu();
    window.location.href = path;
  };

  render() {
    // If the screen is taller than wide, show mobile view
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const mobileView = screenHeight > screenWidth;
    const isValidationSurveyPath =
      window.location.pathname === "/ValidationSurvey" ||
      window.location.pathname === "/ValidationSurvey/";

    const { aboutAnchor, frameworkAnchor, valueAnchor, navigationAnchor, mobileMenuOpen } = this.state;

    return this.state.loading ? (
      <Loading />
    ) : (
      <ThemeProvider theme={theme}>
        <div className="header">
          {/* Mobile: Hamburger menu on left */}
          {mobileView ? (
            <button
              className="mobile-menu-btn"
              onClick={this.toggleMobileMenu}
              aria-label="Open navigation menu"
            >
              <MenuIcon />
            </button>
          ) : (
            <h4 className="title">S-CCATE</h4>
          )}

          {/* Navigation Dropdowns */}
          {!mobileView && (
            <div className="nav-dropdowns">
              {/* About Dropdown */}
              <Button
                className="nav-dropdown-btn"
                onClick={this.handleDropdownOpen("about")}
                endIcon={<KeyboardArrowDownIcon />}
              >
                About
              </Button>
              <Menu
                anchorEl={aboutAnchor}
                open={Boolean(aboutAnchor)}
                onClose={this.handleDropdownClose("about")}
                MenuListProps={{ onMouseLeave: this.handleDropdownClose("about") }}
              >
                {NAV_DROPDOWNS.about.items.map((item) => (
                  <MenuItem
                    key={item.anchor}
                    onClick={this.scrollToSection(item.anchor, "about")}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>

              {/* Framework Dropdown */}
              <Button
                className="nav-dropdown-btn"
                onClick={this.handleDropdownOpen("framework")}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Framework
              </Button>
              <Menu
                anchorEl={frameworkAnchor}
                open={Boolean(frameworkAnchor)}
                onClose={this.handleDropdownClose("framework")}
                MenuListProps={{ onMouseLeave: this.handleDropdownClose("framework") }}
              >
                {NAV_DROPDOWNS.framework.items.map((item) => (
                  <MenuItem
                    key={item.anchor}
                    onClick={this.scrollToSection(item.anchor, "framework")}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>

              {/* Value Dropdown */}
              <Button
                className="nav-dropdown-btn"
                onClick={this.handleDropdownOpen("value")}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Value
              </Button>
              <Menu
                anchorEl={valueAnchor}
                open={Boolean(valueAnchor)}
                onClose={this.handleDropdownClose("value")}
                MenuListProps={{ onMouseLeave: this.handleDropdownClose("value") }}
              >
                {NAV_DROPDOWNS.value.items.map((item) => (
                  <MenuItem
                    key={item.anchor}
                    onClick={this.scrollToSection(item.anchor, "value")}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>

              {/* Navigation Dropdown - Dynamic based on user role */}
              <Button
                className="nav-dropdown-btn"
                onClick={this.handleDropdownOpen("navigation")}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Navigation
              </Button>
              <Menu
                anchorEl={navigationAnchor}
                open={Boolean(navigationAnchor)}
                onClose={this.handleDropdownClose("navigation")}
                MenuListProps={{ onMouseLeave: this.handleDropdownClose("navigation") }}
              >
                <MenuItem
                  onClick={() => {
                    this.handleDropdownClose("navigation")();
                    window.location.href = "/";
                  }}
                >
                  {this.state.sccate_admin ? "Dashboard" : "Welcome"}
                </MenuItem>

                {(this.state.sccate_admin || this.state.user_can_manage || this.props.auth.loggedIn) && (
                  <MenuItem
                    onClick={() => {
                      this.handleDropdownClose("navigation")();
                      window.location.href = "/surveys";
                    }}
                  >
                    Surveys
                  </MenuItem>
                )}

                {(this.state.user_can_manage || this.state.sccate_admin) && (
                  <MenuItem
                    onClick={() => {
                      this.handleDropdownClose("navigation")();
                      window.location.href = "/reports";
                    }}
                  >
                    {!this.state.sccate_admin ? "Manage" : "Reports"}
                  </MenuItem>
                )}

                <MenuItem
                  onClick={() => {
                    this.handleDropdownClose("navigation")();
                    window.location.href = "/csla";
                  }}
                >
                  CSLA
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    this.handleDropdownClose("navigation")();
                    window.location.href = "/more";
                  }}
                >
                  About Us
                </MenuItem>

                {this.props.auth.loggedIn && (
                  <MenuItem
                    onClick={() => {
                      this.handleDropdownClose("navigation")();
                      window.location.href = "/account";
                    }}
                  >
                    Account
                  </MenuItem>
                )}

                {(this.state.sccate_admin_restricted || this.state.sccate_admin) && (
                  <MenuItem
                    onClick={() => {
                      this.handleDropdownClose("navigation")();
                      window.location.href = "/AdminManage";
                    }}
                  >
                    Admin Manage
                  </MenuItem>
                )}
              </Menu>
            </div>
          )}

          <div className="account-info">
            {mobileView ? null : (
              <>
                Phone: 571-213-3192&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </>
            )}
            {!this.props.auth.loggedIn ? (
              <a className="btn btn-primary" href="/Login">
                Login
              </a>
            ) : null}
            {this.props.auth.loggedIn && !mobileView && (
              <>
                Welcome back, {tl.get_logged_in_user()?.first_name} &nbsp;&nbsp;
              </>
            )}
            {this.props.auth.loggedIn && (
              <a className="btn btn-primary" onClick={() => tl.logout_user()}>
                Logout
              </a>
            )}
          </div>
        </div>

        {/* Mobile Navigation Drawer */}
        {mobileView && (
          <>
            <div
              className={`mobile-nav-overlay ${mobileMenuOpen ? "open" : ""}`}
              onClick={this.closeMobileMenu}
            />
            <div className={`mobile-nav-drawer ${mobileMenuOpen ? "open" : ""}`}>
              {/* About Section */}
              <div className="mobile-nav-section">
                <div className="mobile-nav-section-title">About</div>
                {NAV_DROPDOWNS.about.items.map((item) => (
                  <div
                    key={item.anchor}
                    className="mobile-nav-item"
                    onClick={() => {
                      this.closeMobileMenu();
                      if (window.location.pathname !== "/") {
                        window.location.href = `/#${item.anchor}`;
                      } else {
                        const element = document.getElementById(item.anchor);
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>

              {/* Framework Section */}
              <div className="mobile-nav-section">
                <div className="mobile-nav-section-title">Framework</div>
                {NAV_DROPDOWNS.framework.items.map((item) => (
                  <div
                    key={item.anchor}
                    className="mobile-nav-item"
                    onClick={() => {
                      this.closeMobileMenu();
                      if (window.location.pathname !== "/") {
                        window.location.href = `/#${item.anchor}`;
                      } else {
                        const element = document.getElementById(item.anchor);
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>

              {/* Value Section */}
              <div className="mobile-nav-section">
                <div className="mobile-nav-section-title">Value</div>
                {NAV_DROPDOWNS.value.items.map((item) => (
                  <div
                    key={item.anchor}
                    className="mobile-nav-item"
                    onClick={() => {
                      this.closeMobileMenu();
                      if (window.location.pathname !== "/") {
                        window.location.href = `/#${item.anchor}`;
                      } else {
                        const element = document.getElementById(item.anchor);
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>

              {/* Navigation Section */}
              <div className="mobile-nav-section">
                <div className="mobile-nav-section-title">Navigation</div>
                <div
                  className="mobile-nav-item"
                  onClick={() => this.handleMobileNavigation("/")}
                >
                  {this.state.sccate_admin ? "Dashboard" : "Welcome"}
                </div>

                {(this.state.sccate_admin || this.state.user_can_manage || this.props.auth.loggedIn) && (
                  <div
                    className="mobile-nav-item"
                    onClick={() => this.handleMobileNavigation("/surveys")}
                  >
                    Surveys
                  </div>
                )}

                {(this.state.user_can_manage || this.state.sccate_admin) && (
                  <div
                    className="mobile-nav-item"
                    onClick={() => this.handleMobileNavigation("/reports")}
                  >
                    {!this.state.sccate_admin ? "Manage" : "Reports"}
                  </div>
                )}

                <div
                  className="mobile-nav-item"
                  onClick={() => this.handleMobileNavigation("/csla")}
                >
                  CSLA
                </div>

                <div
                  className="mobile-nav-item"
                  onClick={() => this.handleMobileNavigation("/more")}
                >
                  About Us
                </div>

                {this.props.auth.loggedIn && (
                  <div
                    className="mobile-nav-item"
                    onClick={() => this.handleMobileNavigation("/account")}
                  >
                    Account
                  </div>
                )}

                {(this.state.sccate_admin_restricted || this.state.sccate_admin) && (
                  <div
                    className="mobile-nav-item"
                    onClick={() => this.handleMobileNavigation("/AdminManage")}
                  >
                    Admin Manage
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        <BrowserRouter>
          {/* Sidebar menu commented out - replaced with top nav dropdowns
          {!this.props.auth.loggedIn ? (
            <SidebarMenu
              logged_in={this.props.auth.loggedIn}
              sccate_admin={this.state.sccate_admin ?? false}
              sccate_admin_restricted={false}
              user_can_manage={false}
              show={this.state.show}
              showHandler={this.toggleDrawer()}
            />
          ) : null}
          */}
          <div
            className={
              !this.props.auth.loggedIn && !isValidationSurveyPath
                ? mobileView
                  ? "mobile"
                  : "main-no-sidebar"
                : ""
            }
          >
            <Switch>
              <Route path="/ThankYou" exact component={ThankYou} />
              <Route path="/TakeSurvey" exact component={TakeSurvey} />
              <Route
                path="/Login"
                exact
                render={(props) => (
                  <Login {...props} isAuthed={this.props.auth.loggedIn} />
                )}
              />
              <Route
                path="/SignupLogin/:email"
                exact
                render={(props) => (
                  <Login
                    {...props}
                    isAuthed={this.props.auth.loggedIn}
                    signupLogin={true}
                  />
                )}
              />
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/"
                  exact
                  render={(props) => (
                    <Welcome {...props} isAuthed={this.props.auth.loggedIn} />
                  )}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/scla"
                  exact
                  //@ts-ignore
                  render={(props) => <NECLTC {...props} loggedOut={true} />}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/Pricing"
                  exact
                  render={(props) => <Pricing {...props} loggedOut={true} />}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/More"
                  exact
                  render={(props) => (
                    <More {...props} isAuthed={this.props.auth.loggedIn} />
                  )}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/Value"
                  exact
                  render={(props) => (
                    <Value {...props} isAuthed={this.props.auth.loggedIn} />
                  )}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/Pricing/Order/"
                  exact
                  render={(props) => (
                    //@ts-ignore
                    <Order {...props} isAuthed={this.props.auth.loggedIn} />
                  )}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/Validation"
                  exact
                  render={(props) => (
                    <Validation
                      {...props}
                      isAuthed={this.props.auth.loggedIn}
                    />
                  )}
                />
              ) : null}
              <Route
                path="/Register"
                exact
                render={(props) => (
                  //@ts-ignore
                  <Order {...props} isAuthed={this.props.auth.loggedIn} />
                )}
              />
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/InviteLogin/:id"
                  exact
                  render={(props) => (
                    <InviteLogin
                      {...props}
                      isAuthed={this.props.auth.loggedIn}
                    />
                  )}
                />
              ) : null}
              <Route
                path="/Confirm/:userid/:code"
                render={(props) => <Confirm {...props} />}
              />
              {!this.props.auth.loggedIn ? (
                <Route
                  path="/Setup/:userid/:code"
                  render={(props) => <Setup {...props} />}
                />
              ) : null}
              {!this.props.auth.loggedIn ? (
                <Route path="/csla" exact component={NECLTC} />
              ) : null}
              <Route
                render={(props) => (
                  <Main
                    {...props}
                    isAuthed={this.props.auth.loggedIn}
                    show={this.state.show}
                    showHandler={this.toggleDrawer()}
                  />
                )}
              />
            </Switch>
          </div>
        </BrowserRouter>
        <div className="clearfix"></div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state: Props) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(App);
